import { render, staticRenderFns } from "./MetaColumn.vue?vue&type=template&id=351bd539"
import script from "./MetaColumn.vue?vue&type=script&lang=js"
export * from "./MetaColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports